<template>
    <article class="branding page type-page status-publish hentry">

        <header class="entry-header animateIn"  v-lazy:background-image="'https://api.alt-design.net/api/image/' + page.header_image[Math.floor(Math.random() * page.header_image.length)]" >
            <h1 class="entry-title">Digital</h1>
        </header><!-- .entry-header -->

        <div class="entry-content animateIn wrapper">
            <h2 class="alt-title">Where seamless functionality and usability meets crafted design.</h2>
            <!--<p class="sub-title">Does your brand communicate your unique offering and set you apart from your competition?</p>-->
            <div class="cols">
                <div class="col left">
                    <p class="intro">All of our digital and web design projects are made to order based on your individual requirements. We can help you create an online experience that appeals to your users.
                    </p>
                    <p class="intro">
                        Whether it's a reliable e-commerce store or a simple gallery page our studio has the expertise to produce a site that is easy to find, looks good and works hard.</p>
                </div>
                <div class="col right">
                    <div>
                        <p class="intro">We consider:</p>
                        <ul>
                            <li>Design & Development</li>
                            <li>Responsive websites</li>
                            <li>Content Management Systems</li>
                            <li>E-commerce</li>
                            <li>Web Design</li>
                            <li>Email marketing</li>
                            <li>Web apps</li>
                            <li>Mobile</li>
                            <li>Social Media</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="view-work">
                <h2 class="alt-title">View our Digital work</h2>
                <div>
                    <router-link to="/work" class="button">Work</router-link>
                </div>
            </div>
        </div>

    </article>
</template>

<script>
  import ScrollMagic from 'ScrollMagic'
  import TweenMax from 'TweenMax'
  import 'animation.gsap'

  export default {
    data () {
      return {
        page: ''
      }
    },
    methods: {
      setTweens () {
        const slides = document.querySelectorAll('.animateIn')

        for (let slide of slides) {
          new ScrollMagic.Scene({
            triggerElement: slide,
            triggerHook: 'onEnter'
          })
            .setTween(TweenMax.from(slide, 1, {y: 250, opacity: 0}))
            .addTo(window.scrollController)
        }
      }
    },
    created () {
      window.api.get('get-pages/about').then(res => {
        this.page = res.data.data.page
      })
      window.api.get('get-pages-by-type/2').then(res => {
        this.projects = res.data.data
      }).then(() => {
        this.setTweens()
      })
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Pages/About/Digital.vue